"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubRisqueRendementAccepterTrads = void 0;
exports.ESubRisqueRendementAccepterTrads = {
    eleve: "Élevé - Une prise de risque important (perte totale du capital)",
    faible: "Faible - Une prise de risque faible (perte minime du capital)",
    moyen: "Moyen - Une prise de risque modéré (perte de capital acceptée)",
    null: "Nul - Aucune prise de risque",
};
